import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading || store[NAME].isLoadingModules || store[NAME].isLoadingActivities;
export const getCourses = store => store[NAME].courses;
export const getSkillList = store => store[NAME].skillList;
export const getUserFieldsDefinition = store => store[NAME].userFieldsDefinition;
export const getCourse = store => store[NAME].course;
export const getCourseTree = store => store[NAME].courseTree;
export const getModules = store => store[NAME].modules;
export const getActivities = store => store[NAME].activities;
export const getMedia = store => store[NAME].media;
export const getActivityTypes = store => store[NAME].activityTypes;
export const getQuestionTypes = store => store[NAME].questionTypes;
export const getSessionTypes = store => store[NAME].sessionTypes;
export const getActivity = store => store[NAME].activity;